import { useMemo } from "react";
import { useUserList } from "../../../../common/hooks/api/user";
import { toastError } from "../../../../helpers/toast-helper";
import { getResponseData } from "../../../../helpers/response-helper";
import { TSelectOption } from "../../../../common/types/common";

export const useOperatorOptions = (): { options: TSelectOption[]; isLoading: boolean; } => {
    const { data: userList, isLoading } = useUserList({ pagination: { pageSize: 10000, pageIndex: 1 }, sorting: {}, filtering: { } }, {
        onError: () => {
            toastError("Can not fetch operators list");
        },
    });
    const { data: users } = getResponseData(userList);
    const options = useMemo(() => users?.length ? users.map((item) => ({ value: item.id, label: item.displayName || [item.firstName, item.lastName].join(' ')})) : [], [users]);

    return {
        options,
        isLoading,
    };
};
